import type { ReactNode } from 'react';
import { Pill } from '@/shared/ui/pill';

type ConnectionRowProps = {
  logo: ReactNode;
  name: string;
  note: string;
  status: { tone: 'ok' | 'info' | 'warn' | 'off' | 'bad'; label: string };
};

export function ConnectionRow({ logo, name, note, status }: ConnectionRowProps) {
  return (
    <div className="grid min-h-12 grid-cols-1 items-center gap-1.5 border-line py-1.5 not-first:border-t shell:grid-cols-[minmax(120px,170px)_minmax(0,1fr)] shell:gap-4">
      <span className="inline-flex items-center gap-2.5 font-medium">
        {logo}
        {name}
      </span>
      <span className="flex flex-wrap items-center justify-between gap-2">
        <span className="text-meta text-muted">{note}</span>
        <Pill tone={status.tone} hasDot>
          {status.label}
        </Pill>
      </span>
    </div>
  );
}
